var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinusBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 1,
    viewBox: "0 0 11 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11045",
    "data-name": "Group 11045",
    transform: "translate(-4527.816 -22395.004) rotate(-45)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1533",
    "data-name": "Line 1533",
    y2: 10,
    transform: "translate(-12634.012 19038.016) rotate(-45)",
    fill: "none",
    stroke: "#3070c7",
    strokeLinecap: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusBlue);
export default __webpack_public_path__ + "static/media/Minus Blue.188fae316138e0d1b5e145bbadd860da.svg";
export { ForwardRef as ReactComponent };